import { generateUUID } from '@wix/form-schema';
import { useCallback, useMemo, useState } from 'react';
import { useFieldActions } from '../../contexts/field-actions-context';
export const useAtlas = ({ enabled })=>{
    const { actions } = useFieldActions();
    const [sessionToken, setSessionToken] = useState(generateUUID());
    const refreshSessionToken = useCallback(()=>setSessionToken(generateUUID()), []);
    return useMemo(()=>{
        const { predict, getPlace, searchByPostalCode } = actions ?? {};
        if (!enabled || !predict || !getPlace || !searchByPostalCode) {
            return undefined;
        }
        return {
            predict: (params)=>predict({
                    ...params,
                    sessionToken
                }),
            getPlace: (params)=>getPlace({
                    ...params,
                    sessionToken,
                    refreshSessionToken
                }),
            searchByPostalCode: (params)=>searchByPostalCode({
                    ...params,
                    sessionToken
                })
        };
    }, [
        enabled,
        actions,
        sessionToken,
        refreshSessionToken
    ]);
};

//# sourceMappingURL=use-atlas.js.map